<template>
    <el-dialog :title="shopName + '商品经营范围费率设置'" :visible.sync="dialogVisible" width="600px" @close="handleClose" top="10vh" heigth="80vh" :close-on-click-modal="false" :close-on-press-escape="false" @open="dialogDidOpen">
        <el-table :data="data" style="width: 100%"  :highlight-current-row="true" height="50vh">
            <el-table-column prop="scopeName" label="商品经营范围" ></el-table-column>
            <el-table-column prop="saleFeePer" label="商业公司类型费率" >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.saleFeePer" placeholder="请输入" @input="(e)=>handleInput(e, scope.row ,'saleFeePer')">
                        <template slot="append">%</template>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column prop="otherFeePer" label="其他公司类型费率">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.otherFeePer" placeholder="请输入" @input="(e)=>handleInput(e, scope.row ,'otherFeePer')">
                        <template slot="append">%</template>
                    </el-input>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSave">保存</el-button>
            <el-button @click="handleBack">返回</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { plServiceChargeRules, plProductBagFeeConfigsSaveFeeConfigList } from '@/api/saleRule/agent'
export default {
    name: 'SalesRateDialog',
    props: {
       shopId: {
            type: String,
            required: true,
        },
        shopName: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            dialogVisible: false,
            data: [],
        }
    },
    methods: {
        handleSave() {
            // 过滤空值
            const postData = this.data.filter(item => item.saleFeePer || item.otherFeePer)
            const obj = {
                shopName: this.shopName,
                shopId: this.shopId,
                detailQOList: postData
            }
            if (postData.length === 0) {
                this.$message.error('请至少设置一条费率')
                return
            }
            const findEmpty = postData.find(item => !item.saleFeePer || !item.otherFeePer)
            if (findEmpty) {
                this.$message.error('请填写完整费率')
                return
            }
            plProductBagFeeConfigsSaveFeeConfigList(obj).then(res => {
                this.$message.success('保存成功')
                this.handleBack()
            })
        },
        handleBack() {
            this.dialogVisible = false
        },
        handleDialogVisible() {
            this.dialogVisible = true
        },
       
        handleClose() {
            this.form = {
                scopeName: '',
                sort: 0
            }
            this.handleBack()
        },
        dialogDidOpen() {
            if (!this.shopId) {
                return
            }
            const obj = {
                shopId: this.shopId
            }
            plServiceChargeRules(obj).then(res => {
                this.data = res
            })
        },
         handleInput (value, row , column) {
            let val = this.toStringFs(value);
            let localPrecisionNumber = 2;
            const regString = `^\\D*(\\d*(?:\\.\\d{0,${localPrecisionNumber}})?).*$`; ///^\D*(\d*(?:\.\d{0,3})?).*$/g
            const regExp = new RegExp(regString, "g");
            val = val.replace(regExp, "$1");
            // val = toFixedFs(val);
            // return val;
            row[column] = val;
        },
        toStringFs(value) {
            if (typeof value === "number") {
                value = String(value);
            }
            return value;
            }
        }

}
</script>


<style scoped lang="scss"></style>